import React from 'react';
import HelpButton from './HelpButton';

const Footer = ({ buttons = null, center = null }) => {
  return (
    <div className="bottomBar">
      <div className="container">
        <div className="d-flex align-items-center">
          <HelpButton />
          {center && <div style={{ flex: '1 1 0%' }} />}
          {center && <div className="flex-shrink-0">{center}</div>}
          <div
            style={center ? { flex: '1 1 0%' } : undefined}
            className={`d-flex flex-wrap gap-3 justify-content-end${center ? '' : ' flex-grow-1'}`}
          >
            {buttons}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;